import React from 'react';
import styled from 'styled-components';
import APP_STORES from 'constants/appStores';
import trackAppPrompt from './trackAppPrompt';

const BADGES = {
    ios: { src: '/assets/images/stores/app-store-badge.svg', alt: 'Baixar o Whizr na App Store' },
    android: { src: '/assets/images/stores/google-play-badge.svg', alt: 'Baixar o Whizr no Google Play' },
};

/**
 * Badges oficiais das lojas. Com `platform` mostra só a loja do aparelho;
 * sem ele, as duas.
 */
export default function StoreBadges({ platform = null, source, onStoreClick }) {
    const stores = platform ? [platform] : ['ios', 'android'];

    function handleClick(store) {
        trackAppPrompt('app_store_click', { store, source });
        onStoreClick?.(store);
    }

    return (
        <Badges>
            {stores.map((store) => (
                <BadgeLink
                    key={store}
                    href={APP_STORES[store]}
                    target='_blank'
                    rel='noopener noreferrer'
                    onClick={() => handleClick(store)}
                >
                    <img src={BADGES[store].src} alt={BADGES[store].alt} width={135} height={40} />
                </BadgeLink>
            ))}
        </Badges>
    );
}

const Badges = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
`;

const BadgeLink = styled.a`
    display: inline-flex;
    border-radius: 7px;
    transition: transform ease-in-out .2s;

    & > img {
        display: block;
        height: 40px;
        width: auto;
    }

    &:hover {
        transform: scale(1.03);
    }

    &:focus-visible {
        outline: 2px solid #1D4ED8;
        outline-offset: 2px;
    }
`;
